import * as types from "./mutation-type";
import { getjobCodesQuery } from "./queries.graphql";
import gqlClient from "@/modules/graphql";
import api from "@/modules/api";

const actions = {
  async getJobCodes({ commit }, variables = {}) {
    try {
      commit(types.GET_JOBCODES_BEGIN);

      const {
        data: {
          data: {
            company: { jobCodes }
          }
        }
      } = await gqlClient.query({
        query     : getjobCodesQuery,
        variables : variables
      });
      commit(types.GET_JOBCODES_SUCCESS, jobCodes);
    } catch (e) {
      commit(types.GET_JOBCODES_ERROR, e);
    }
  },
  async deleteJobCode({ commit }, id) {
    try {
      commit(types.DELETE_JOBCODE_BEGIN);
      await api.jobCode.deleteJobCode(id);
      commit(types.DELETE_JOBCODE_SUCCESS, id);
    } catch (e) {
      commit(types.DELETE_JOBCODE_ERROR, e);
    }
  },
  async createJobCode({ commit }, variables) {
    try {
      commit(types.ADD_JOBCODE_BEGIN);
      const { data } =  await api.jobCode.createJobCode(variables);
      commit(types.ADD_JOBCODE_SUCCESS, data);
    } catch (e) {
      commit(types.ADD_JOBCODE_ERROR, e);
    }
  },
  async updateJobCode({ commit }, { id,data }) {
    try {
      commit(types.UPDATE_JOBCODE_BEGIN);
      const { data : updateData } =  await api.jobCode.updateJobCodes(id,data);
      commit(types.UPDATE_JOBCODE_SUCCESS, updateData);
    } catch (e) {
      commit(types.UPDATE_JOBCODE_ERROR, e);
    }
  }
};

export default actions;
